<template>
  <div id="lm-upload-files" v-if="showComponent" class="">
    <label class="mb-4 d-flex justify-content-between">
      {{label}} <small v-if="required">*</small>
      <div>
        <font-awesome-icon
          id="font-awesome-icon-edit"
          icon="edit"
          size="sm"
          class="clickable float-right mt-1"
          :class="{ 'ml-2': help }"
          v-if="showEditButton"
          @click="$emit('edit-button-clicked')"
        />
        <font-awesome-icon
          icon="question-circle"
          size="sm"
          class="clickable float-right mt-1"
          v-if="help"
          v-b-tooltip.hover="help"
        />
      </div>
    </label>
    <!--Modal-->
    <b-modal v-model="show" id="modal-1" centered size="lg" :title="$t('upload_image')">
      <div>
    <!--Cropper-->
    <!-- stencil-component="circle-stencil" -->
      <cropper  ref="cropper" :src="src" v-if="src"  />
      <!--Buttons-->
      <div class="mt-2 mb-2 d-flex justify-content-center" v-if="src" >
        <b-button variant="dark" @click="crop">
          <i class="mdi mdi-crop"></i>
        </b-button>
        <b-button variant="dark" @click="rotate(90)">
          <i class="mdi mdi-format-rotate-90 mdi-flip-v" ></i>
        </b-button>
        <b-button variant="dark" class="d-flex justify-content-center align-items-center" @click="flip(-1,0)">
          <i class="mdi mdi-format-horizontal-align-center" ></i>
        </b-button>
        <b-button variant="dark" class="d-flex justify-content-center align-items-center" @click="flip(0,-1)">
          <i class="mdi mdi-format-vertical-align-center" ></i>
        </b-button>
      </div>
      <!--Preview-->
      <div class="text-center preview" v-if="preview">
        <h5>{{ $t('titulo_ventana_preview') }}</h5>
        <div class="mt-2 text-center preview-dashed">
          <img :src="preview" alt="Preview">
        </div>
      </div>
      <!--File input-->
      <div class="button-wrapper">
           <b-form-file
              :placeholder="$t('select_file')"
              :drop-placeholder="$t('select_file')"
              :browse-text="$t('browse')"
              @change="loadImage($event)"
              accept="image/*"
            ></b-form-file>
      </div>
    </div>
    <!-- Footer modal -->
    <template #modal-footer>
        <b-button v-b-modal.modal-modal-1 variant="secondary" @click="show=false">{{ $t('cancel') }}</b-button>
        <b-button v-b-modal.modal-modal-1 variant="primary" @click="modalOk">Ok</b-button>
    </template>
    </b-modal>
    <!--Botón Subir Imagen-->
    <div  class="mb-3">
      <img :src="urlAssets + image.path" class="img-preview" alt="Preview" v-if="image.path">
      <div class="mt-3" v-if="image.size">{{ formatBytes(image.size) }}</div>
      <b-button variant="outline-secondary" class="mt-2 mb-1" @click="reset" v-if="image.path"> <font-awesome-icon
          icon="trash"
          size="sm"
        /> {{$t('delete')}}</b-button>
    </div>
    <b-button variant="primary" @click="modalShow" class="mb-3"><i class="mdi mdi-upload"></i> {{ $t(indication) }}</b-button>
  </div>
</template>

<script>
import { Cropper, CircleStencil } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import lmInputMixin from '@/mixins/lmInputMixin.js'
import commonsApi from '@/api/commons'

/**
* LmUploadImage es un wrapper de advanced-cropper
*
* https://advanced-cropper.github.io/vue-advanced-cropper/
*
*/

// Esta función se utiliza para detectar el tipo de imagen,
function getMimeType (file, fallback = null) {
  const byteArray = (new Uint8Array(file)).subarray(0, 4)
  let header = ''
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16)
  }
  switch (header) {
    case '89504e47':
      return 'image/png'
    case '47494638':
      return 'image/gif'
    case 'ffd8ffe0':
    case 'ffd8ffe1':
    case 'ffd8ffe2':
    case 'ffd8ffe3':
    case 'ffd8ffe8':
      return 'image/jpeg'
    default:
      return fallback
  }
}

export default {
  mixins: [lmInputMixin],
  components: {
    Cropper,
    CircleStencil
  },
  data () {
    return {
      image: {
        uuid: null,
        name: null,
        path: null,
        size: null,
        type: null,
        ext: null
      },
      src: null,
      preview: null,
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      show: false,
      validations: {
        required: false
      }
    }
  },
  computed: {
    urlToUploadFiles () {
      return process.env.VUE_APP_API_URL + 'upload/'
    },
    urlAssets () {
      return process.env.VUE_APP_API_URL_STATIC_ASSETS
    },
    indication () {
      if (this.placeholder) {
        return this.placeholder
      }
      return 'upload_image'
    }
  },
  methods: {
    formatBytes (bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    modalShow () {
      // Reseteo valores cuando se abre el modal
      this.src = null
      this.preview = null
      this.show = true
    },
    modalOk (event) {
      try {
        const { canvas } = this.$refs.cropper.getResult()
        if (canvas) {
          canvas.toBlob((blob) => {
          // Sube la imagen al servidor
            const formData = new FormData()
            formData.append('file', blob, this.image.name)
            this.uploadImage(formData)
          }, this.image.type)
        }
        this.show = false
      } catch (error) {
        console.error('debe cargar una imagen...')
      }
    },
    crop () {
      const { coordinates, canvas } = this.$refs.cropper.getResult()
      this.coordinates = coordinates
      if (canvas) {
        this.preview = canvas.toDataURL()
      }
    },
    async uploadImage (formData) {
      const url = this.urlToUploadFiles
      const response = await commonsApi.axiosPostMultipartWrapper(url, formData)
      let ext = this.image.type.split('/')
      ext = ext.pop()
      this.image.path = response.data.path
      this.image.size = response.data.size
      this.image.ext = ext
    },
    reset () {
      this.image = {
        uuid: null,
        name: null,
        path: null,
        size: null,
        type: null,
        src: null,
        ext: null
      }
    },
    loadImage (event) {
      const { files } = event.target

      if (files && files[0]) {
        // Revoke the object URL, para permitir que el recolector de basura destruya el archivo cargado antes
        if (this.src) {
          URL.revokeObjectURL(this.src)
        }
        // Crea el vínculo del blob al archivo para optimizar el rendimiento:
        const blob = URL.createObjectURL(files[0])
        // Genero el uuid
        let uuid = blob.split('/')
        uuid = uuid.pop()
        // Crea un nuevo FileReader para leer los datos binarios de esta imagen
        const reader = new FileReader()
        // Define un callback cuando FileReader ternina de cargar
        reader.onload = (e) => {
          this.image = {
            uuid: uuid,
            name: files[0].name,
            path: null,
            src: blob,
            type: getMimeType(e.target.result, files[0].type)
          }
          this.src = blob
        }
        // Inicia el trabajo del lector: lea el archivo como una URL de datos (formato base64)
        reader.readAsArrayBuffer(files[0])
      }
    },
    flip (x, y) {
      this.$refs.cropper.flip(x, y)
    },
    rotate (angle) {
      this.$refs.cropper.rotate(angle)
    }
  },
  destroyed () {
    if (this.src) {
      URL.revokeObjectURL(this.src)
    }
  },
  watch: {
    image (val) {
      if (val) {
        this.$emit('input', this.image)
      }
    },
    value (val) {
      if (val) {
        this.image = val
      }
    }
  }
}
</script>

<style scoped lang="sass">
// General
.d-flex
  // agrega espacios entre los botones, crop, rotate, flip, etc..
  gap: 6px
// Preview del modal
.preview
  margin-top: 30px
  margin-bottom: 30px
  h5
    margin-bottom: 0px
  .preview-dashed
    display: inline-block
    border: 2px #444 dashed
    margin: 0px auto
    img
      max-width: 100%
// Preview arriba del botón
.img-preview
  max-width: 100%
  // border-radius: 50%
</style>
